import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()(() => {
    return {
        wrapper: {
            textTransform: 'capitalize',
        },
    }
})

export default useStyles
